"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function store(initial) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!initial) {
    throw new Error('initial state is required');
  }

  var _ = {
    state: initial,
    setState: setState
  };

  function setState(changes) {
    // check only in development
    validateChanges(initial, changes);
    Object.assign(_.state, changes);
    Object.keys(changes).forEach(function (field) {
      return handlers[field] && handlers[field](changes[field]);
    });
  }

  return _;
}

function validateChanges(initial, changes) {
  if ((0, _typeof2.default)(changes) !== 'object') {
    throw new Error('provided value of changes should be an object');
  }

  if (Object.keys(changes).some(function (field) {
    return !initial.hasOwnProperty(field);
  })) {
    throw new Error('It seams you want to change a field in the state that is not specified in the "initial" state');
  }
}

var _default = store;
exports.default = _default;